import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_DM_REPUTATION_LAYER = createFcmDetails('dm_reputation_layer', {
	owner: 'Capybara',
	context: 'DM Reputation Layer',
	description: 'Feature flag to enable the DM Reputation Layer on DM profile page',
	import: false,
	template: {
		enabled: false,
	},
	mergeLogic: 'If either locale or country is enabled, feature is enabled. Otherwise falls back to global value.',
});
